var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"msr","medium":""}},[_vm._v("\n        volume_off\n      ")])],1),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-layout',{attrs:{"align-center":"","wrap":""}},[_vm._v("\n        "+_vm._s(_vm.$t('radioDecoderIsSilencedHint'))+"\n      ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DecoderDetail/RadioDecoderSilencedWarning.vue?vue&type=template&id=a3822222&
// module id = 2252
// module chunks = 5